import { rem } from 'polished'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'
import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'
import commonMessages from 'i18n/commonMessages'

const CardContent = styled.div`
  padding: ${rem(40)} ${rem(16)};
`

function CruiseSoldoutDepartureCard() {
  const intl = useIntl()

  return <Pane shadow="bottom-small">
    <CardContent>
      <Group direction="vertical" horizontalAlign="center" gap={16}>
        <BodyText variant="large" weight="bold" align="center">
          {intl.formatMessage({
            id: '2U-9c39nu0JOEGwyzQ54',
            defaultMessage: 'No departures available',
          })}
        </BodyText>
        <TextButton kind="secondary" to="/cruises">
          {intl.formatMessage(commonMessages.browseAllCruiseOffers)}
        </TextButton>
      </Group>
    </CardContent>
  </Pane>
}

export default CruiseSoldoutDepartureCard
